"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var json_1 = require("../../../common/helpers/json");
var StudentSettingsPoliciesCancellationController = /** @class */ (function () {
    function StudentSettingsPoliciesCancellationController($scope, $state, UsersModel, FlashService, UserService) {
        var _this = this;
        this.formData = {};
        this.$state = $state;
        this.FlashService = FlashService;
        this.UsersModel = UsersModel;
        this.UserService = UserService;
        UsersModel.getStudentByID(this.UserService.getCurrentUser().id).then(function (response) {
            var metadata = {};
            response.usermeta.forEach(function (meta) {
                metadata[meta.meta_key] = (0, json_1.isJson)(meta.meta_value)
                    ? JSON.parse(meta.meta_value)
                    : meta.meta_value;
            });
            response.usermeta = metadata;
            if (!response.usermeta.hasOwnProperty("communication")) {
                response.usermeta.communication = {};
            }
            _this.user = response;
        });
    }
    StudentSettingsPoliciesCancellationController.prototype.submit = function () {
        var _this = this;
        this.UsersModel.updateStudentSettings(this.user).then(function (response) {
            _this.$state.go("drivecoach.student.settings");
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        });
    };
    return StudentSettingsPoliciesCancellationController;
}());
StudentSettingsPoliciesCancellationController.$inject = [
    "$scope",
    "$state",
    "UsersModel",
    "FlashService",
    "UserService",
];
exports.default = StudentSettingsPoliciesCancellationController;
